import type { FaireProductEntity } from "../../entity_types/product";

export const p_pcwbyysd4v: FaireProductEntity = {
  token: "p_pcwbyysd4v",
  type: "product",
  name: "Chocolate Pecan Fudge with Home-Roasted Pecans",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/18c0a17edd08885f1b8ad2830528de6ee41be54f7f31bc318795b871da492bb5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/974fb852f11f1f1e7b07404450e78ab3c31b93ed8f41702071523f0eddcd0320.jpeg",
  ],
  priceDollars: 7.58,
  description:
    "Chocolate Pecan is our classic southern fudge using pecans from sunny Georgia. We mix lots of pecans throughout the chocolate so there is plenty of crunch in every tub. FREE SHIPPING on all orders over $55. \n\nChocolate Pecan in a 1/2 lb resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:27.345Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
